import store from '../store'
import { Platform, Notify } from 'quasar'

import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'

const routes = [
	//Não logado
	{
		path: '/',
		component: () => import('layouts/NotAuthenticated.vue'),
		children: [
			{
				path: '',
				name: 'login',
				component: () => import('pages/login/Login.vue'),
				props: true,
			},
			{
				path: 'maintenance-login',
				name: 'maintenance-login',
				component: () => import('pages/login/Login.vue'),
				props: true,
			},
			{
				path: 'login-samsung',
				name: 'login-samsung',
				component: () => import('pages/login/Login.vue'),
				props: true,
			},
			{
				path: 'redirect-control-pannel-v2',
				name: 'redirect-control-pannel-v2',
				component: () => import('pages/login/Login.vue'),
				props: true,
			},
			{
				path: 'recover-password',
				name: 'recover-password',
				component: () => import('pages/login/RecoverPassword.vue'),
			},
			{
				path: 'recover-password',
				name: 'recover-password-pop-trade',
				component: () => import('pages/login/RecoverPassword.vue'),
			},
			{
				path: 'recover-password',
				name: 'recover-password-seven-trade',
				component: () => import('pages/login/RecoverPassword.vue'),
			},
			{
				path: 'recover-password/:username/:uidb64/:token',
				name: 'set-new-password',
				component: () => import('pages/login/SetNewPassword.vue'),
				props: true,
			},
			{
				path: 'set-password/:username/:uidb64/:token',
				name: 'set-password',
				component: () => import('pages/login/SetNewPassword.vue'),
				props: true,
			},
			{
				path: 'register',
				name: 'register',
				component: () => import('pages/login/Register.vue'),
			},
			{
				path: 'register-pop-trade',
				name: 'register-pop-trade',
				component: () => import('pages/login/RegisterPopSevenTrade.vue'),
			},
			{
				path: 'register-seven-trade',
				name: 'register-seven-trade',
				component: () => import('pages/login/RegisterPopSevenTrade.vue'),
			},
			{
				path: 'about',
				name: 'about',
				component: () => import('pages/institutional/About.vue'),
			},
			{
				path: 'privacy',
				name: 'privacy',
				component: () => import('pages/institutional/Privacy.vue'),
			},
			{
				path: 'terms',
				name: 'terms',
				component: () => import('pages/institutional/Terms.vue'),
			},
			{
				path: 'help',
				name: 'login-help',
				component: () => import('pages/institutional/Help.vue'),
			},
		],

		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			// Nova senha
			// if (to.name == 'set-new-password' && to.params.username != undefined && process.env.APP_CORDOVA_URL && process.env.APP_CORDOVA_URL != ''){
			// 	if (Platform.is.mobile && !Platform.is.cordova) {
			// 		console.log(`${process.env.APP_CORDOVA_URL}://recover-password/?origin=recover-password&username=${to.params.username}&uidb64=${to.params.uidb64}&token=${to.params.token}`)
			// 		window.location = `${process.env.APP_CORDOVA_URL}://recover-password/?origin=recover-password&username=${to.params.username}&uidb64=${to.params.uidb64}&token=${to.params.token}`
			// 	}
			// }
			// Novo Usuario
			if (to.name === 'set-password' && to.params.username != undefined) {
				if (Platform.is.mobile && !Platform.is.cordova) {
					window.location = `${
						process.env.APP_CORDOVA_URL
					}://set-password/?origin=set-password&username=${to.params.username}&uidb64=${
						to.params.uidb64
					}&token=${to.params.token}`
				}
			}
			// Nova mensagem
			if (to.query.message_id != undefined) {
				if (Platform.is.mobile && !Platform.is.cordova) {
					window.location = `${
						process.env.APP_CORDOVA_URL
					}://?origin=message&message_id=${to.query.message_id}`
				}
			}
			//Webinar Samsung
			if (to.name === 'login-samsung') {
				if (Platform.is.mobile && !Platform.is.cordova) {
					window.location = `${
						process.env.APP_CORDOVA_URL
					}://login-samsung/?origin=login-samsung&access_token=${
						to.query.access_token
					}&expires_in=${to.query.expires_in}&refresh_token=${
						to.query.refresh_token
					}&result=${to.query.result}&scope=${to.query.scope}&token_type=${
						to.query.token_type
					}&user_firebase_token=${to.query.user_firebase_token}`
				}
			}

			if (store.getters['common/access_token'] && to.name !== 'login-samsung' && to.name !== 'redirect-control-pannel-v2') {
				let clients = store.getters['params/clients']
				let id_user_client_selected = store.getters['common/id_user_client_selected']
				var obj = clients.find((obj) => {
					return obj.id === id_user_client_selected
				})

				next({ name: 'admin_overview', query: to.query })
			} else {
				clearUserData()
				next()
			}
		},
	},
	//Logado
	{
		path: '/',
		component: () => import('layouts/Authenticated.vue'),
		children: [
			{
				path: 'home',
				name: 'home',
				component: () =>
					Platform.is.mobile
						? import('pages/home/HomeMobile.vue')
						: import('pages/home/Home.vue'),
				meta: { title: 'home' },
			},
			{
				path: 'feed',
				name: 'feed',
				component: () => import('pages/feed/Feed.vue'),
				meta: { title: 'feed' },
			},
			{
				path: 'courses',
				name: 'courses',
				component: () => import('pages/courses/Courses.vue'),
				meta: { title: 'courses' },
				props: true,
			},
			{
				path: 'courses/:id',
				name: 'course',
				component: () => import('pages/courses/Course.vue'),
				meta: { title: 'courses' },
				props: true,
			},
			{
				path: 'trails',
				name: 'trails',
				component: () => import('pages/trails/Trails.vue'),
				meta: { title: 'trails' },
				props: true,
			},
			{
				path: 'trails/:id',
				name: 'trail',
				component: () => import('pages/trails/Trail.vue'),
				meta: { title: 'trails' },
				props: true,
			},
			{
				path: 'trails/:id_trail/course/:id',
				name: 'trail_course',
				component: () => import('pages/courses/Course.vue'),
				meta: { title: 'trails' },
				props: true,
			},
			{
				path: 'webcasts',
				name: 'webcasts',
				component: () => import('pages/webcasts/Webcasts.vue'),
				meta: { title: 'webcasts' },
				props: true,
			},
			{
				path: 'webcasts/:id',
				name: 'webcast',
				component: () => import('pages/webcasts/Webcast.vue'),
				meta: { title: 'webcasts' },
				props: true,
			},
			{
				path: 'podcasts',
				name: 'podcasts',
				component: () => import('pages/podcasts/Podcasts.vue'),
				meta: { title: 'podcasts' },
			},
			{
				path: 'presential',
				name: 'presential',
				component: () => import('pages/presential/Presential.vue'),
				meta: { title: 'presential' },
				props: true,
			},
			{
				path: 'presential',
				name: 'presentials',
				component: () => import('pages/presential/Presential.vue'),
				meta: { title: 'presential' },
				props: true,
			},
			{
				path: 'presential/:id',
				name: 'view_presential',
				component: () => import('pages/presential/ViewPresential.vue'),
				meta: { title: 'presential' },
				props: true,
			},
			{
				path: 'library',
				name: 'library',
				component: () =>
					Platform.is.mobile
						? import('pages/library/LibraryMobile.vue')
						: import('pages/library/Library.vue'),
				meta: { title: 'library' },
				props: true,
			},
			{
				path: 'library/:name',
				name: 'library-search-name',
				component: () =>
					Platform.is.mobile
						? import('pages/library/LibraryMobile.vue')
						: import('pages/library/Library.vue'),
				meta: { title: 'library' },
				props: true,
			},
			{
				path: 'calendar',
				name: 'calendar',
				component: () => import('pages/calendar/Calendar.vue'),
				meta: { title: 'calendar' },
			},
			{
				path: 'profile',
				name: 'profile',
				component: () => import('pages/profile/Profile.vue'),
				meta: { title: 'profile' },
			},
			{
				path: 'profile',
				name: 'profile_basic_data',
				component: () => import('pages/profile/Profile.vue'),
				meta: { title: 'profile' },
			},
			{
				path: 'profile',
				name: 'profile_certificates',
				component: () => import('pages/profile/Profile.vue'),
				meta: { title: 'profile' },
			},
			{
				path: 'news',
				name: 'news',
				component: () => import('pages/news/News.vue'),
				meta: { title: 'news' },
			},
			{
				path: 'news/:id',
				name: 'news_modal',
				component: () => import('pages/news/News.vue'),
				meta: { title: 'news' },
			},
			{
				path: 'institutional/help',
				name: 'help',
				component: () => import('pages/institutional/Help.vue'),
				meta: { title: 'help' },
			},
			{
				path: 'institutional/faq',
				name: 'faq',
				component: () => import('pages/institutional/Faq.vue'),
				meta: { title: 'faq' },
			},
			{
				path: 'institutional/about',
				name: 'institutional-about',
				component: () => import('pages/institutional/About.vue'),
				meta: { title: 'about' },
			},
			{
				path: 'institutional/privacy',
				name: 'institutional-privacy',
				component: () => import('pages/institutional/Privacy.vue'),
				meta: { title: 'privacy' },
			},
			{
				path: 'institutional/terms',
				name: 'institutional-terms',
				component: () => import('pages/institutional/Terms.vue'),
				meta: { title: 'terms' },
			},
			{
				path: 'messages',
				name: 'messages',
				component: () => import('pages/messages/Messages.vue'),
				meta: { title: 'messages' },
			},
			{
				path: 'live_classes',
				name: 'live_classes',
				component: () => import('pages/live_classes/LiveClasses.vue'),
				meta: { title: 'live_classes' },
			},
			{
				path: 'live_classes/:id',
				name: 'live_class',
				component: () => import('pages/live_classes/LiveClass.vue'),
				meta: { title: 'live_class' },
			},
			// LIVE_CLASS REDIRECT FOR V2 EMAIL LINKS
			{
				path: 'live-classes',
				redirect: 'live_classes',
			},
			{
				path: 'live-classes/:id',
				redirect: 'live_classes/:id',
			},
		],

		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}

			if (!store.getters['common/access_token']) {
				clearUserData()
				store.dispatch('redirect/SET_REDIRECT', [to.path])
				next({ name: 'login' })
			} else if (!store.getters['params/params_loaded']) {
				checkAllowed(next, to, from, 'authenticated')
			} else {
				if (store.getters['redirect/redirect'] !== '') {
					let redirect = store.getters['redirect/redirect']
					store.dispatch('redirect/SET_REDIRECT', [''])

					next({ path: redirect })
				} else if (store.getters['params/tmp_system_new_version'])
					checkSystemNewVersion(next)
				else {
					next()
				}
			}
		},
	},
	//Admin
	{
		path: '/admin',
		component: () => import('layouts/Admin.vue'),
		children: [
			{
				path: 'overview',
				name: 'admin_overview',
				component: () => import('pages/admin/overview/Overview.vue'),
				meta: { title: 'overview' },
			},
			{
				path: 'tags',
				name: 'admin_tags',
				component: () => import('pages/admin/tag/Tags.vue'),
				meta: { title: 'tags' },
			},
			{
				path: 'tags/:id',
				name: 'admin_tag',
				component: () => import('pages/admin/tag/Tag.vue'),
				meta: { title: 'tags' },
				props: true,
			},
			{
				path: 'trainings',
				name: 'admin_trainings',
				component: () => import('pages/admin/training/Trainings.vue'),
				meta: { title: 'trainings' },
			},
			{
				path: 'trainings/:id',
				name: 'admin_training',
				component: () => import('pages/admin/training/Training.vue'),
				meta: { title: 'trainings' },
				props: true,
			},
			{
				path: 'trails',
				name: 'admin_trails',
				component: () => import('pages/admin/trails/Trails.vue'),
				meta: { title: 'trails' },
			},
			{
				path: 'trails/:id',
				name: 'admin_trail',
				component: () => import('pages/admin/trails/Trail.vue'),
				meta: { title: 'trails' },
				props: true,
			},
			{
				path: 'trail/categories',
				name: 'admin_trail_categories',
				component: () => import('pages/admin/trails/Categories.vue'),
				meta: { title: 'trails' },
			},
			{
				path: 'trail/categories/:id',
				name: 'admin_trail_category',
				component: () => import('pages/admin/trails/Category.vue'),
				meta: { title: 'trails' },
			},
			{
				path: 'general-tests',
				name: 'admin_general_tests',
				component: () => import('pages/admin/general_tests/GeneralTests.vue'),
				meta: { title: 'general_tests' },
			},
			{
				path: 'general-tests/:id',
				name: 'admin_general_test',
				component: () => import('pages/admin/general_tests/GeneralTest.vue'),
				meta: { title: 'general_tests' },
				props: true,
			},
			{
				path: 'library/categories',
				name: 'admin_library_categories',
				component: () => import('pages/admin/library/Categories.vue'),
				meta: { title: 'library_categories' },
			},
			{
				path: 'library/categories/:id',
				name: 'admin_library_category',
				component: () => import('pages/admin/library/Category.vue'),
				meta: { title: 'library_categories' },
				props: true,
			},
			{
				path: 'libraries',
				name: 'admin_libraries',
				component: () => import('pages/admin/library/Libraries.vue'),
				meta: { title: 'library' },
			},
			{
				path: 'libraries/:id',
				name: 'admin_library',
				component: () => import('pages/admin/library/Library.vue'),
				meta: { title: 'library' },
			},
			{
				path: 'webcasts',
				name: 'admin_webcasts',
				component: () => import('pages/admin/webcasts/Webcasts.vue'),
				meta: { title: 'webcasts' },
			},
			{
				path: 'webcasts/:id',
				name: 'admin_webcast',
				component: () => import('pages/admin/webcasts/Webcast.vue'),
				meta: { title: 'webcasts' },
			},
			{
				path: 'podcasts',
				name: 'admin_podcasts',
				component: () => import('pages/admin/podcasts/Podcasts.vue'),
				meta: { title: 'podcasts' },
			},
			{
				path: 'podcasts/:id',
				name: 'admin_podcast',
				component: () => import('pages/admin/podcasts/Podcast.vue'),
				meta: { title: 'podcasts' },
			},
			{
				path: 'users',
				name: 'admin_users',
				component: () => import('pages/admin/users/Users.vue'),
				meta: { title: 'users' },
			},
			{
				path: 'users/:id',
				name: 'admin_user',
				component: () => import('pages/admin/users/User.vue'),
				meta: { title: 'users' },
				props: true,
			},
			{
				path: 'users-groups',
				name: 'admin_users_groups',
				component: () => import('pages/admin/users/UsersGroups.vue'),
				meta: { title: 'users_groups' },
			},
			{
				path: 'users-groups/:id',
				name: 'admin_users_group',
				component: () => import('pages/admin/users/UsersGroup.vue'),
				meta: { title: 'users_groups' },
				props: true,
			},
			{
				path: 'home',
				name: 'admin_home',
				component: () => import('pages/admin/configuration/Home.vue'),
				meta: { title: 'home' },
			},
			{
				path: 'wild_cards',
				name: 'admin_wild_cards',
				component: () => import('pages/admin/wild_card/WildCards.vue'),
				meta: { title: 'wild_card' },
			},
			{
				path: 'wild_card/:id',
				name: 'admin_wild_card',
				component: () => import('pages/admin/wild_card/WildCard.vue'),
				meta: { title: 'wild_card' },
			},
			{
				path: 'import-code',
				name: 'import_code',
				component: () => import('pages/admin/configuration/AppleCode.vue'),
				meta: { title: 'import_code' },
			},
			{
				path: 'area_config',
				name: 'area_config',
				component: () => import('pages/admin/configuration/Areas.vue'),
				meta: { title: 'area_config' },
			},
			{
				path: 'mailing_list_config',
				name: 'mailing_list_config',
				component: () => import('pages/admin/configuration/MailingList.vue'),
				meta: { title: 'mailing_list' },
			},
			{
				path: 'admin-imports',
				name: 'admin_imports',
				component: () => import('pages/admin/imports/Imports.vue'),
				meta: { title: 'admin_import' },
			},
			{
				path: 'admin-import/:id',
				name: 'admin_import',
				component: () => import('pages/admin/imports/Import.vue'),
				meta: { title: 'admin_import' },
				props: true,
			},
			{
				path: 'organization-headquarters',
				name: 'admin_headquarters',
				component: () => import('pages/admin/organization/Headquarters.vue'),
				meta: { title: 'headquarter' },
			},
			{
				path: 'organization-headquarters/:id',
				name: 'admin_headquarter',
				component: () => import('pages/admin/organization/Headquarter.vue'),
				meta: { title: 'headquarter' },
				props: true,
			},
			{
				path: 'headquarter-import',
				name: 'admin_headquarter_import',
				component: () => import('pages/admin/organization/HeadquartersImport.vue'),
				meta: { title: 'headquarter_import' },
				props: true,
			},
			{
				path: 'organization-branches',
				name: 'admin_branches',
				component: () => import('pages/admin/organization/Branches.vue'),
				meta: { title: 'branch' },
			},
			{
				path: 'organization-branches/:id',
				name: 'admin_branch',
				component: () => import('pages/admin/organization/Branch.vue'),
				meta: { title: 'branch' },
				props: true,
			},
			{
				path: '4traders/questions/',
				name: '4traders_questions',
				component: () => import('pages/admin/4traders/Questions.vue'),
				meta: { title: '4traders_questions' },
			},
			{
				path: '4traders/questions/:id',
				name: '4traders_question',
				component: () => import('pages/admin/4traders/Question.vue'),
				meta: { title: '4traders_questions' },
				props: true,
			},
			{
				path: '4traders/tasks/',
				name: '4traders_tasks',
				component: () => import('pages/admin/4traders/Tasks.vue'),
				meta: { title: '4traders_tasks' },
			},
			{
				path: '4traders/tasks/:id',
				name: '4traders_task',
				component: () => import('pages/admin/4traders/Task.vue'),
				meta: { title: '4traders_tasks' },
				props: true,
			},
			{
				path: 'presential/courses-catalog/',
				name: 'courses_catalog',
				component: () => import('pages/admin/courses_catalog/CoursesCatalog.vue'),
				meta: { title: 'presential_manager_catalog' },
				props: true,
			},
			{
				path: 'presential/course-catalog/:id',
				name: 'course_catalog',
				component: () => import('pages/admin/courses_catalog/CourseCatalog.vue'),
				meta: { title: 'presential_manager_catalog' },
				props: true,
			},
			{
				path: 'presential/planned-vacancies/',
				name: 'planned_vacancies',
				component: () => import('pages/admin/planned_vacancies/PlannedVacancies.vue'),
				meta: { title: 'presential_manager_seats' },
				props: true,
			},
			{
				path: 'presential/planned-vacancy/:id',
				name: 'planned_vacancy',
				component: () => import('pages/admin/planned_vacancies/PlannedVacancy.vue'),
				meta: { title: 'presential_manager_seats' },
				props: true,
			},
			{
				path: 'presential/categories-modules/',
				name: 'product_categories',
				component: () => import('pages/admin/presential/CategoriesModules.vue'),
				meta: { title: 'product_categories' },
				props: true,
			},
			{
				path: 'presential/categories-modules/:id',
				name: 'product_category',
				component: () => import('pages/admin/presential/CategoryModule.vue'),
				meta: { title: 'product_categories' },
				props: true,
			},
			{
				path: 'presential/products/',
				name: 'products',
				component: () => import('pages/admin/presential/Products.vue'),
				meta: { title: 'products' },
				props: true,
			},
			{
				path: 'presential/products/:id',
				name: 'product',
				component: () => import('pages/admin/presential/Product.vue'),
				meta: { title: 'products' },
				props: true,
			},
			{
				path: 'presential/materials/',
				name: 'support_materials',
				component: () => import('pages/admin/presential/Materials.vue'),
				meta: { title: 'support_materials' },
				props: true,
			},
			{
				path: 'presential/materials/:id',
				name: 'support_material',
				component: () => import('pages/admin/presential/Material.vue'),
				meta: { title: 'support_materials' },
				props: true,
			},
			{
				path: 'presential/appointment-types/',
				name: 'appointment_types',
				component: () => import('pages/admin/presential/AppointmentTypes.vue'),
				meta: { title: 'appointment_types' },
				props: true,
			},
			{
				path: 'presential/appointment-types/:id',
				name: 'appointment_type',
				component: () => import('pages/admin/presential/AppointmentType.vue'),
				meta: { title: 'appointment_types' },
				props: true,
			},
			{
				path: 'presential/appointments/',
				name: 'appointments',
				component: () => import('pages/admin/presential/Appointments.vue'),
				meta: { title: 'appointments' },
				props: true,
			},
			{
				path: 'presential/appointment/:id',
				name: 'appointment',
				component: () => import('pages/admin/presential/Appointment.vue'),
				meta: { title: 'appointments' },
				props: true,
			},
			{
				path: 'presential/calendar/',
				name: 'presential_calendar',
				component: () => import('pages/admin/presential/Calendar.vue'),
				meta: { title: 'appointments' },
				props: true,
			},
			{
				path: 'news',
				name: 'admin_news',
				component: () => import('pages/admin/news/News.vue'),
				meta: { title: 'news' },
			},
			{
				path: 'news/:id',
				name: 'admin_news_edit',
				component: () => import('pages/admin/news/NewsEdit.vue'),
				meta: { title: 'news' },
				props: true,
			},
			{
				path: 'banners',
				name: 'admin_banners',
				component: () => import('pages/admin/banners/Banners.vue'),
				meta: { title: 'banners' },
			},

			{
				path: 'banners/:id',
				name: 'admin_banner',
				component: () => import('pages/admin/banners/Banner.vue'),
				meta: { title: 'banners' },
				props: true,
			},
			{
				path: 'banners-welcome',
				name: 'banners_welcome',
				component: () => import('pages/admin/banners_welcome/BannersWelcome.vue'),
				meta: { title: 'banners_welcome' },
			},
			{
				path: 'banners-welcome/:id',
				name: 'banner_welcome',
				component: () => import('pages/admin/banners_welcome/BannerWelcome.vue'),
				meta: { title: 'banners_welcome' },
				props: true,
			},
			{
				path: 'surveys',
				name: 'admin_surveys',
				component: () => import('pages/admin/surveys/Surveys.vue'),
				meta: { title: 'surveys' },
			},
			{
				path: 'surveys/:id',
				name: 'admin_survey',
				component: () => import('pages/admin/surveys/Survey.vue'),
				meta: { title: 'surveys' },
			},
			{
				path: 'drills',
				name: 'admin_drills',
				component: () => import('pages/admin/drills/Drills.vue'),
				meta: { title: 'drills' },
			},
			{
				path: 'drills/:id',
				name: 'admin_drill',
				component: () => import('pages/admin/drills/Drill.vue'),
				meta: { title: 'drills' },
			},
			{
				path: 'faqs',
				name: 'admin_faqs',
				component: () => import('pages/admin/faq/Faqs.vue'),
				meta: { title: 'faq' },
			},
			{
				path: 'faqs/:id',
				name: 'admin_faq',
				component: () => import('pages/admin/faq/Faq.vue'),
				meta: { title: 'faq' },
				props: true,
			},
			{
				path: 'messages',
				name: 'admin_messages',
				component: () => import('pages/admin/messages/Messages.vue'),
				meta: { title: 'messages' },
			},
			{
				path: 'messages/:id',
				name: 'admin_message',
				component: () => import('pages/admin/messages/Message.vue'),
				meta: { title: 'messages' },
				props: true,
			},
			{
				path: 'faq/categories',
				name: 'admin_faq_categories',
				component: () => import('pages/admin/faq/FaqCategories.vue'),
				meta: { title: 'faq_categories' },
			},
			{
				path: 'faq/categories/:id',
				name: 'admin_faq_category',
				component: () => import('pages/admin/faq/FaqCategory.vue'),
				meta: { title: 'faq_categories' },
				props: true,
			},
			{
				path: 'configuration',
				name: 'admin_config',
				component: () => import('pages/admin/configuration/Configuration.vue'),
				meta: { title: 'configuration' },
			},
			{
				path: 'terms',
				name: 'admin_terms',
				component: () => import('pages/admin/configuration/Terms.vue'),
				meta: { title: 'terms' },
			},
			{
				path: 'about',
				name: 'admin_about',
				component: () => import('pages/admin/configuration/About.vue'),
				meta: { title: 'about' },
			},
			{
				path: 'policy',
				name: 'admin_policy',
				component: () => import('pages/admin/configuration/Policy.vue'),
				meta: { title: 'policy' },
			},
			{
				path: 'cookies_policy',
				name: 'admin_cookies_policy',
				component: () => import('pages/admin/configuration/CookiesPolicy.vue'),
				meta: { title: 'cookies_policy' },
			},
			{
				path: 'badges',
				name: 'admin_badges',
				component: () => import('pages/admin/configuration/Badges.vue'),
				meta: { title: 'badges' },
			},
			{
				path: 'badges/:id',
				name: 'admin_badge',
				component: () => import('pages/admin/configuration/Badge.vue'),
				meta: { title: 'badges' },
				props: true,
			},
			{
				path: 'schedule',
				name: 'schedules',
				component: () => import('pages/admin/schedule/Schedules.vue'),
				meta: { title: 'schedule' },
			},
			{
				path: 'schedule/:id',
				name: 'schedule',
				component: () => import('pages/admin/schedule/Schedule.vue'),
				meta: { title: 'schedule' },
				props: true,
			},
			{
				path: 'live_classes',
				name: 'admin_live_classes',
				component: () => import('pages/admin/live_classes/LiveClasses.vue'),
				meta: { title: 'live_classes' },
			},
			{
				path: 'live_classes/:id',
				name: 'admin_live_class',
				component: () => import('pages/admin/live_classes/LiveClass.vue'),
				meta: { title: 'live_classes' },
				props: true,
			},
		],

		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}

			if (!store.getters['common/access_token']) {
				next({ name: 'login' })
			} else {
				checkAllowed(next, to, from, 'admin')
			}
		},
	},
	{
		path: '/app-store',
		component: () => import('pages/app-store/AppStore.vue'),
		name: 'app-store',
	},
]

if (process.env.MODE !== 'ssr') {
	routes.push({
		path: '*',
		component: () => import('pages/Error404.vue'),
	})
}

export default routes

function checkAllowed(next, to, from, module_to) {
	let super_user_routes = [
		'admin_config',
		'admin_terms',
		'admin_about',
		'admin_policy',
		'admin_badges',
		'admin_badge',
		'admin_imports',
		'admin_home',
		'admin_wild_cards',
		'admin_wild_card',
		'import_code',
		'area_config',
	]
	let special_permissions = ['appointments']

	if (
		module_to == 'admin' &&
		!super_user_routes.includes(to.name) &&
		!special_permissions.includes(to.meta.title)
	) {
		var access_level = store.getters['common/user_module_items']
		var allowed = false

		if (access_level.length > 0) {
			var obj_raw = access_level.find((obj) => {
				return obj.slug == to.meta.title
			})
			if (obj_raw) allowed = obj_raw.permission
		}

		if (allowed) next()
		else if (from.path === '/' || from.name === 'set-new-password') {
			Notify.create({
				message: 'Usuário não possui acesso ao painel de controle!',
				type: 'negative',
			})

			clearUserData()
			clearFireBase()
			next({ name: 'login' })
		} else notAllowed(next)
	} else if (module_to == 'admin' && super_user_routes.includes(to.name)) {
		if (store.getters['common/is_superuser']) {
			next()
		} else notAllowed(next)
	} else if (module_to == 'admin' && special_permissions.includes(to.meta.title)) {
		let has_permission = false

		let obj = store.getters['common/user_module_items'].find((obj) => {
			return obj.slug === 'request_events'
		})
		if (obj && obj.permission === true) has_permission = true

		obj = store.getters['common/user_module_items'].find((obj) => {
			return obj.slug === 'approve_events'
		})
		if (obj && obj.permission === true) has_permission = true

		obj = store.getters['common/user_module_items'].find((obj) => {
			return obj.slug === 'finish_events'
		})
		if (obj && obj.permission === true) has_permission = true

		if (has_permission) {
			next()
		} else notAllowed(next)
	} else next()
}

function notAllowed(next) {
	let clients = store.getters['params/clients']
	let id_user_client_selected = store.getters['common/id_user_client_selected']
	let obj = clients.find((obj) => {
		return obj.id == id_user_client_selected
	})
	next(obj.home_route)
}

function clearUserData() {
	store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])
	store.dispatch('common/SET_USER_DATA', [
		'',
		'',
		'',
		'',
		'',
		'',
		'',
		[],
		[],
		[],
		,
		false,
		'',
		[],
		false,
		'',
		[],
		[],
	])
}

function clearFireBase() {
	firebase
		.auth()
		.signOut()
		.then(() => {})
		.catch((e) => {
			console.log(e)
		})
}

function checkSystemNewVersion(next) {
	var access_level = store.getters['common/user_module_items']
	var allowed = false
	if (access_level.length > 0) {
		var obj_raw = access_level.find((obj) => {
			return obj.permission == true
		})
		if (obj_raw) allowed = obj_raw.permission
		if (allowed) next({ name: 'admin_overview' })
		else {
			clearUserData()
			clearFireBase()
			next({ name: 'login' })
		}
	} else {
		clearUserData()
		clearFireBase()
		next({ name: 'login' })
	}
}
